// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGUserLoginIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer",
  width: "35px"
};

export default class SVGUserLoginIcon extends PureComponent<
  ISVGUserLoginIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 35}
        fill={fill || "currentColor"}
        style={style}
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M16.523,0.002c4.224-0.061,6.968,1.028,8.367,3.754
	c0.889,1.73,1.017,5.044,0.47,7.271c-0.193,0.784-0.156,1.389-0.391,2.111c-1.146,3.516-2.892,6.021-6.725,6.882
	c-1.761,0.395-3.414-0.569-4.301-1.173c-1.917-1.305-3.048-3.277-3.832-5.708c-0.277-0.861-0.245-1.636-0.469-2.58
	C9.278,9.024,9.25,6.463,9.721,5.007c0.664-2.051,2-3.577,3.91-4.379c0.5-0.209,1.145-0.342,1.642-0.469
	C15.69,0.053,16.206,0.2,16.523,0.002z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M12.849,20.647c0.163,0.029,0.15,0.018,0.235,0.078
	c0.39,0.425,0.536,1.077,0.86,1.564c0.677,1.019,1.57,1.96,2.425,2.815c0.369,0.369,0.722,0.986,1.25,1.173
	c0.39-0.607,1.065-1.055,1.564-1.564c0.685-0.7,1.411-1.609,1.954-2.424c0.302-0.453,0.509-1.504,1.095-1.642
	c0.609,0.406,2.465,0.587,3.284,0.86c3.652,1.212,7.995,2.781,8.915,6.725c0,0.443,0,0.886,0,1.329c0,1.611,0.036,2.995-0.625,3.91
	c-1.176,1.628-3.816,1.564-6.647,1.564c-4.925,0-9.853,0-14.779,0c-3.47,0-8.396,0.564-10.478-0.938
	c-0.505-0.365-0.982-1.135-1.173-1.799c-0.271-0.944-0.165-3.625,0.078-4.457c1.069-3.659,5.211-5.167,8.758-6.334
	C10.328,21.255,12.314,21.026,12.849,20.647z"
        />
      </svg>
    );
  }
}
